module.exports = __webpack_public_path__ + "media/images/emblems/Baeriswil-coat_of_arms-73f2a6739e85b38705d5de6bd302bfda.svg";